export const SUB_POSITION = {
  HEADER: "Header",
  FOOTER: "Footer",
  BDS: "Bất động sản",
  DU_AN: "Dự án",
  UU_DAI: "Ưu đãi & Khuyến mãi",
};
